export default __webpack_public_path__ + "static/media/mySQL.ddb2e543.png";